import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight, GlassWater, X } from "lucide-react";
import { cocktailMenu } from "@/craftCocktails";

export const BriefDrawer = ({ selectedCocktailIds, onRemove }) => {
  const [open, setOpen] = useState(false);
  const items = cocktailMenu.filter((cocktail) => selectedCocktailIds.includes(cocktail.id));
  const count = items.length;

  useEffect(() => {
    if (count === 0) setOpen(false);
  }, [count]);

  const goToQuote = () => {
    setOpen(false);
    document.getElementById("reserve")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      <AnimatePresence>
        {count > 0 && (
          <motion.button
            type="button"
            className="brief-fab"
            onClick={() => setOpen(true)}
            data-testid="brief-drawer-fab"
            aria-label={`View event brief, ${count} pours selected`}
            initial={{ opacity: 0, y: 24, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 24, scale: 0.9 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            whileHover={{ y: -3 }}
            whileTap={{ scale: 0.96 }}
          >
            <GlassWater size={18} />
            <span className="brief-fab-label">Your brief</span>
            <span className="brief-fab-count" data-testid="brief-drawer-count">{count}</span>
          </motion.button>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {open && (
          <>
            <motion.div
              className="brief-drawer-backdrop"
              onClick={() => setOpen(false)}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              data-testid="brief-drawer-backdrop"
            />
            <motion.aside
              className="brief-drawer"
              role="dialog"
              aria-modal="true"
              aria-label="Your event brief"
              data-testid="brief-drawer-panel"
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            >
              <div className="brief-drawer-head">
                <div>
                  <span className="card-eyebrow">Event brief</span>
                  <h3>{count} {count === 1 ? "pour" : "pours"} chosen</h3>
                </div>
                <button type="button" className="brief-drawer-close" onClick={() => setOpen(false)} aria-label="Close brief" data-testid="brief-drawer-close">
                  <X size={18} />
                </button>
              </div>

              <div className="brief-drawer-list">
                {items.map((cocktail) => (
                  <div className="brief-item" key={cocktail.id} data-testid={`brief-item-${cocktail.id}`}>
                    <img src={cocktail.image} alt={cocktail.name} />
                    <div className="brief-item-copy">
                      <span className="brief-item-category">{cocktail.categoryLabel}</span>
                      <strong>{cocktail.name}</strong>
                    </div>
                    <button
                      type="button"
                      className="brief-item-remove"
                      onClick={() => onRemove(cocktail.id)}
                      aria-label={`Remove ${cocktail.name} from brief`}
                      data-testid={`brief-remove-${cocktail.id}`}
                    >
                      <X size={15} />
                    </button>
                  </div>
                ))}
              </div>

              <div className="brief-drawer-foot">
                <p>Carry these into your tailored quote — we’ll build the menu around them.</p>
                <button type="button" className="button button-primary brief-drawer-quote" onClick={goToQuote} data-testid="brief-drawer-quote-cta">
                  Continue to your quote <ArrowUpRight size={16} />
                </button>
              </div>
            </motion.aside>
          </>
        )}
      </AnimatePresence>
    </>
  );
};
